// extracted by mini-css-extract-plugin
export default {"TabList":"WiFfpmIK","FullWidth":"hncwZE0T","Tab":"_lp6tG46","Position-center":"a2hRdhpi","Position-left":"nlMAtFVw","Position-right":"LwIquXMv","TabPanel":"PQjLHRzB"};